import React, { Component, Fragment } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { resizing, showModal, hideModal } from './store/ui';
import { routeChanged } from './store/globals';

import RouteOrError from './components/RouteOrError';

import Header from './components/Header';
import StepsList from './components/StepsList';
import Aside from './components/Aside';

import Login from './pages/Login';
import Tickets from './pages/Tickets';
import Seats from './pages/Seats';
import Payments from './pages/Payments';
import Error from './pages/Error';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentPayPalCallback from './pages/PaymentPayPalCallback';
import PaymentCallbackSuccess from './pages/PaymentCallbackSuccess';
import PaymentCallbackError from './pages/PaymentCallbackError';
import Footer from './components/Footer';
import MobileTopBar from './components/MobileTopBar';
import Modal from './components/Modal';
import LocalRedirect from './components/LocalRedirect';
import localSessionStorage from './services/localSessionStorage';

import { CautionIcon } from './components/Icons';


class App extends Component {

  constructor(props) {
    super(props);

    this.debouncedResizing = debounce(this.props.resize, 300);
  }

  componentDidMount() {
    this.props.setLoading(false)
    window.addEventListener('resize', this.debouncedResizing, false);
    window.addEventListener('popstate', this.props.handleRouteChanged, false);

    if (this.props.activeModal) {
      this.props.showModal({ type: this.props.activeModal.section, position: 'main' });
    }
    if (this.props.activeModalPayment)
      this.props.showModal({ type: 'payment', position: 'main' });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeModal !== this.props.activeModal && this.props.activeModal) {
      this.props.showModal({ type: this.props.activeModal.section, position: 'main' });
    }

    if (prevProps.activeModalPayment !== this.props.activeModalPayment && this.props.activeModalPayment)
      this.props.showModal({ type: 'payment', position: 'main' });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResizing, false);
    window.removeEventListener('popstate', this.props.handleRouteChanged, false);
  }

  guardPaymentsRoute = () => {
    if (this.props.seatsSessionId === null || this.props.selectedTickets.length <= 0) {
      return true;
    }

    return false;
  };

  render() {
    const { modal, overlay, isMobile, activeModal, activeModalPayment, iframeUrl } = this.props;
    const { pathname } = this.props.location;
    const blurred = !isMobile && modal !== null && modal.position === 'main' && activeModalPayment;
    const simpleView = !(isMobile && (pathname === '/' || pathname === '/error' || pathname === '/confirmacion'));

    return (
      <Fragment>
        <Header blurred={blurred} />

        <div className="page-wrap">
          <Aside blurred={blurred} />

          <section className="main-wrap" role="main">
            <div className={blurred ? ' blur-overlay' : ''}>
              <MobileTopBar />
              <StepsList />
            </div>

            <section className="main">
              <div className={blurred ? ' blur-overlay' : ''}>
                <Switch>
                  <RouteOrError path="/" exact component={Login} />
                  <RouteOrError path="/entradas" component={Tickets} />
                  <RouteOrError path="/butacas" component={Seats} />
                  <RouteOrError path="/pago" exact component={Payments} guard={this.guardPaymentsRoute()} />
                  <Route path="/error" component={Error} />
                  <Route path="/confirmacion" component={PaymentSuccess} />
                  <Route path="/pago/callback" component={PaymentPayPalCallback} />
                  <Route path="/pago/success/callback" component={PaymentCallbackSuccess} />
                  <Route path="/pago/error/callback" component={PaymentCallbackError} />
                  <Route render={() => {
                    localSessionStorage.clear();
                    return <LocalRedirect to="/error" />;
                  }} />
                </Switch>
              </div>

              {
                modal !== null && modal.position === 'main' && activeModal &&
                <Modal
                  className="modal--main"
                  accept={this.props.hideModal}
                  acceptText="OK, ENTENDIDO"
                  title={activeModal.title}
                  icon={<CautionIcon />}
                  iconWidth="21px"
                >
                  <p className="text">{activeModal.message}</p>
                </Modal>
              }
              {
                modal !== null && modal.position === 'main' && activeModalPayment &&
                <Modal
                  className="modal--main"
                  accept={this.props.hideModal}
                  iframeUrl={iframeUrl}
                >
                </Modal>
              }
            </section>
          </section>
        </div>

        <Footer blurred={blurred} extraSpace={simpleView} linksData={this.props.footer} />
        <div className={`overlay ${overlay ? 'active' : ''}`}></div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ showtime, ui, globals, tickets, payments }) => {
  const { modal, overlay, isMobile } = ui;
  const { showtimeInfo } = showtime;
  return {
    modal, overlay, isMobile,
    activeModal: showtimeInfo && showtimeInfo.alerts ? showtimeInfo.alerts.find(alert => {
      let route = globals.route.replace(/(compra|\/)/g, '');
      if (route === 'entradas') { route = 'tickets'; }
      if (route === 'butacas') { route = 'seats'; }
      if (route === 'pago') { route = 'purchases'; }
      return alert.section === route;
    }) : null,
    activeModalPayment: payments.type === 'spreedly_tickets' && payments.isLoading && globals.route === '/pago',
    seatsSessionId: globals.sessionId,
    selectedTickets: tickets.selectedTickets,
    footer: showtime.footer,
    iframeUrl: showtime.settings !== null && typeof showtime.settings.others.spreedly_iframe !== 'undefined' ? showtime.settings.others.spreedly_iframe : null//validar
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    resize: () => {
      if (window.innerWidth < 1024) {
        dispatch(resizing(true, window.innerWidth));
      } else {
        dispatch(resizing(false, window.innerWidth));
      }
    },
    handleRouteChanged: () => dispatch(routeChanged(ownProps.history.location.pathname)),
    showModal: (obj) => dispatch(showModal(obj)),
    hideModal: () => dispatch(hideModal())
  }
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));
